import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertNotice,
} from 'shared/components';
import './RoomSetup.scss';

const RoomSetup = ({openRoomButton, firstTask, roomType}) => {
  const { t } = useTranslation();

  if(!firstTask || firstTask?.displayOrder !== 1){
    return null;
  }
  const firstTaskWithBr = firstTask?.instructions.replace(/\r\n/g,"<br />");

    return (
      <div>
        <h5>{t('taskManagement.roomSetupTitle')}</h5>
        <div>
        {roomType ?
        <p dangerouslySetInnerHTML={{ __html: firstTaskWithBr }}></p>
        :
         <AlertNotice
            message={t('taskManagement.roomTypeWarning')}
            type='warning'
          />}
          {openRoomButton}
        </div>
      </div>
    );
  }

export default RoomSetup;
